function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import PictureComponent from "components/core/picture/picture-component";
import { PICTURE_WITH_LINK_CLICKED } from "/constants/bigbrain-event-types";
class PictureWithLinkComponent extends PureComponent {
    render() {
        const _this_props = this.props, { href, target } = _this_props, otherProps = _object_without_properties(_this_props, [
            "href",
            "target"
        ]);
        if (href) {
            return /*#__PURE__*/ _jsx("a", {
                href: href,
                target: target,
                onClick: this.onClick,
                children: /*#__PURE__*/ _jsx(PictureComponent, _object_spread({}, otherProps))
            });
        }
        return /*#__PURE__*/ _jsx(PictureComponent, _object_spread({}, otherProps));
    }
    constructor(...args){
        super(...args);
        _define_property(this, "onClick", (e)=>{
            const { href, src } = this.props;
            const isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", PICTURE_WITH_LINK_CLICKED, {
                kind: href,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: src
            });
        });
    }
}
export { PictureWithLinkComponent as default };
PictureWithLinkComponent.defaultProps = {
    target: "_self"
};
